import { useState } from "react";
import {
  AiOutlineShoppingCart,
  AiOutlineHome,
  AiOutlineAppstoreAdd,
} from "react-icons/ai";
import { BiCart, BiLogOut } from "react-icons/bi";
import {
  BsArrowUp,
  BsCart3,
  BsFillBoxFill,
  BsFillInboxFill,
  BsGraphUpArrow,
  BsPeople,
} from "react-icons/bs";
import { MdDashboard } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../../redux/features/auth/authSlice";

const navItem = [
  {
    id: "acb",
    name: "Products",
    icon: <BsFillInboxFill className="text-xl" />,
    url: "/admin/products",
  },
  {
    id: "ae3b",
    name: "Analytics",
    icon: <BsArrowUp className="text-xl" />,
    url: "/admin/analytics",
  },
  {
    id: "aeb",
    name: "Customers",
    icon: <BsPeople className="text-xl" />,
    url: "/admin/customers",
  },
  {
    id: "aaa",
    name: "Orders",
    icon: <BiCart className="text-xl " />,
    url: "/admin/orders",
  },
  {
    id: "aasa",
    name: "Add Product",
    icon: <AiOutlineAppstoreAdd className="text-xl " />,
    url: "/admin/addproduct",
  },
];

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [navIndex, setNavIndex] = useState(11);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(logout());
    setNavIndex(188);
    navigate("/");
  };
  return (
    <div
      className={`bg-white text-slate-600 border-BlueDark border-t     lg:flex lg:flex-col justify-between    transition-all duration-300 px-1 lg:px-0  ${
        isOpen ? "w-full lg:w-56 " : " w-full lg:w-10 lg:flex  lg:translate-x-0"
      }`}
    >
      <div className="header lg:flex-1 flex flex-row lg:flex-col justify-between lg:justify-start  lg:mb-20 ">
        <Link
          to="/admin"
          onClick={() => setNavIndex(11)}
          className={`flex flex-col lg:flex-row items-center cursor-pointer lg:hover:bg-YellowDark py-2   ${
            isOpen ? "lg:pl-5 lg:[&>*]:mx-2 " : "justify-center items-center"
          } ${
            navIndex === 11 && " lg:bg-YellowDark text-YellowDark lg:text-Light"
          }`}
        >
          <MdDashboard className="text-xl" />
          {isOpen && <h1 className="flex-1 hidden lg:block">Dashboard</h1>}
          <h1 className=" whitespace-nowrap lg:hidden  text-[11px]  md:text-lg ">
            Dashboard
          </h1>
        </Link>
        {navItem.map((item, index) => {
          return (
            <Link
              key={item.id}
              to={`${item.url} `}
              className={`${item.name === "Customers" && "hidden"}`}
            >
              <div
                onClick={() => setNavIndex(index)}
                className={`flex flex-col lg:flex-row items-center cursor-pointer lg:hover:bg-YellowDark py-2 lg:my-1  ${
                  isOpen
                    ? "lg:pl-5 lg:[&>*]:mx-2 "
                    : "justify-center items-center"
                } ${
                  navIndex === index &&
                  " lg:bg-YellowDark text-YellowDark lg:text-Light"
                }`}
              >
                {item.icon}
                {isOpen && (
                  <h1 className="flex-1 hidden md:block whitespace-nowrap">
                    {item.name}
                  </h1>
                )}
                <h1 className=" whitespace-nowrap lg:hidden text-[11px] md:text-lg">
                  {item.name}
                </h1>
              </div>
            </Link>
          );
        })}

        <button
          // to="/admin"

          onClick={logoutHandler}
          className={`flex flex-col lg:flex-row items-center cursor-pointer lg:hover:bg-YellowDark py-2   ${
            isOpen ? "lg:pl-5 lg:[&>*]:mx-2 " : "justify-center items-center"
          } ${
            navIndex === 188 &&
            " lg:bg-YellowDark text-YellowDark lg:text-Light"
          }`}
        >
          <BiLogOut className="text-xl" />
          {isOpen && <h1 className="flex-1 hidden lg:block">Logout</h1>}
          <h1 className=" whitespace-nowrap lg:hidden  text-[11px]  md:text-lg ">
            Logout
          </h1>
        </button>
      </div>
    </div>
  );
};

export default SideBar;
